import React from 'react';
import { useFormContext } from 'react-hook-form';
import { UploadIcon } from 'lucide-react';
const ExistingEstateDocuments = () => {
  const {
    register,
    watch
  } = useFormContext();
  const hasExistingWill = watch('existingDocuments.hasWill');
  return <div className="space-y-8" data-id="element-433">
      <div className="bg-slate-50 p-4 rounded-lg border border-slate-200 mb-6" data-id="element-434">
        <p className="text-slate-700" data-id="element-435">
          Please provide information about any existing estate planning
          documents you may have.
        </p>
      </div>
      {/* Existing Will */}
      <div className="space-y-4" data-id="element-436">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-437">
          Existing Will
        </h3>
        <div data-id="element-438">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-439">
            Do you have an existing Will?
          </label>
          <div className="flex items-center space-x-4 mb-4" data-id="element-440">
            <label className="inline-flex items-center" data-id="element-441">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="true" {...register('existingDocuments.hasWill')} data-id="element-442" />
              <span className="ml-2" data-id="element-443">Yes</span>
            </label>
            <label className="inline-flex items-center" data-id="element-444">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="false" {...register('existingDocuments.hasWill')} data-id="element-445" />
              <span className="ml-2" data-id="element-446">No</span>
            </label>
          </div>
          {hasExistingWill === 'true' && <div data-id="element-447">
              <label className="block text-navy-800 font-medium mb-2" data-id="element-448">
                Upload existing Will (optional)
              </label>
              <div className="border-2 border-dashed border-slate-300 rounded-md p-4 text-center" data-id="element-449">
                <UploadIcon className="mx-auto h-12 w-12 text-slate-400" data-id="element-450" />
                <p className="mt-2 text-sm text-slate-600" data-id="element-451">
                  Drag and drop your file here, or click to select
                </p>
                <input type="file" className="hidden" id="will-upload" {...register('existingDocuments.willFile')} data-id="element-452" />
                <button type="button" onClick={() => document.getElementById('will-upload')?.click()} className="mt-2 px-4 py-2 bg-navy-700 text-white text-sm rounded-md hover:bg-navy-800" data-id="element-453">
                  Select File
                </button>
              </div>
              <p className="text-sm text-slate-500 mt-2" data-id="element-454">
                Accepted file formats: PDF, DOC, DOCX, JPG, PNG (Max size: 10MB)
              </p>
            </div>}
        </div>
      </div>
      {/* Estate Trustee */}
      <div className="space-y-4" data-id="element-455">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-456">
          Estate Trustee
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-457">
          <div data-id="element-458">
            <label className="block text-navy-800 font-medium mb-2" data-id="element-459">Name</label>
            <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Enter trustee's name" {...register('estateTrustee.name')} data-id="element-460" />
          </div>
          <div data-id="element-461">
            <label className="block text-navy-800 font-medium mb-2" data-id="element-462">
              Relationship
            </label>
            <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="e.g., Spouse, Child, Friend" {...register('estateTrustee.relationship')} data-id="element-463" />
          </div>
          <div data-id="element-464">
            <label className="block text-navy-800 font-medium mb-2" data-id="element-465">City</label>
            <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Enter city" {...register('estateTrustee.city')} data-id="element-466" />
          </div>
        </div>
        <p className="text-sm text-slate-500 mt-2" data-id="element-467">
          Your Estate Trustee (also called Executor) is responsible for
          administering your estate after your death.
        </p>
      </div>
      {/* Alternate Trustee */}
      <div className="space-y-4" data-id="element-468">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-469">
          Alternate Trustee
        </h3>
        <p className="text-sm text-slate-600 mb-4" data-id="element-470">
          An Alternate Trustee acts if your primary Trustee is unable or
          unwilling to serve.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-471">
          <div data-id="element-472">
            <label className="block text-navy-800 font-medium mb-2" data-id="element-473">Name</label>
            <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Enter alternate trustee's name" {...register('alternateTrustee.name')} data-id="element-474" />
          </div>
          <div data-id="element-475">
            <label className="block text-navy-800 font-medium mb-2" data-id="element-476">
              Relationship
            </label>
            <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="e.g., Sibling, Friend" {...register('alternateTrustee.relationship')} data-id="element-477" />
          </div>
          <div data-id="element-478">
            <label className="block text-navy-800 font-medium mb-2" data-id="element-479">City</label>
            <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Enter city" {...register('alternateTrustee.city')} data-id="element-480" />
          </div>
        </div>
      </div>
    </div>;
};
export default ExistingEstateDocuments;